module.exports = require("@angular/material");


//////////////////
// WEBPACK FOOTER
// external "@angular/material"
// module id = 5
// module chunks = 0